<!-- We'll want our page wrapped in the app-page component which handles errors. -->
<app-page [(error)]="error">&nbsp;</app-page>
